import React, { createContext, useContext } from "react";
import {useSidebar} from "../ui/sidebar";

const AdministrationContext = createContext(undefined);

export const useAdministrationContext = () => useContext(AdministrationContext);

export const AdministrationContextProvider = ({ children }) => {
  const { user, setUser } = useSidebar();

  return <AdministrationContext.Provider value={{ user, setUser }}>{children}</AdministrationContext.Provider>;
};

export default AdministrationContextProvider;
